module.exports = __webpack_public_path__ + "media/app/assets/specializations/evoker/preservation-b72c6da62c3303ce3101bbd43cf4edae.png";